export default {"src":"/_next/static/media/keypad.f4cdf298.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};